import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-neutral-950 text-white py-12">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo & Info */}
          <div className="lg:col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_auto-feed-importer/artifacts/jqtpdh6n_CAVW_Logo.PNG"
              alt="CAVW Logo"
              className="h-12 mb-4"
            />
            <p className="text-zinc-400 text-sm">
              Concessionaria auto usate certificate. Qualità garantita, prezzi trasparenti.
            </p>
          </div>

          {/* Indirizzo */}
          <div>
            <h4 
              className="font-bold text-lg mb-4 uppercase tracking-wide"
              style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
            >
              Dove Siamo
            </h4>
            <a 
              href="https://maps.google.com/?q=Via+Provinciale+di+Mercatale+214+Vinci+FI"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start gap-3 text-zinc-400 hover:text-white transition-colors"
            >
              <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
              <span className="text-sm">
                Via Provinciale di Mercatale, 214/222<br />
                50059 Vinci (FI)
              </span>
            </a>
          </div>

          {/* Contatti */}
          <div>
            <h4 
              className="font-bold text-lg mb-4 uppercase tracking-wide"
              style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
            >
              Contatti
            </h4>
            <div className="space-y-3">
              <a 
                href="tel:+390571902390"
                className="flex items-center gap-3 text-zinc-400 hover:text-white transition-colors"
              >
                <Phone className="w-5 h-5" />
                <span className="text-sm">+39 0571 902390</span>
              </a>
              <a 
                href="mailto:info@cavw.it"
                className="flex items-center gap-3 text-zinc-400 hover:text-white transition-colors"
              >
                <Mail className="w-5 h-5" />
                <span className="text-sm">info@cavw.it</span>
              </a>
              <a 
                href="https://wa.me/390571902390"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-zinc-400 hover:text-white transition-colors"
              >
                <MessageCircle className="w-5 h-5" />
                <span className="text-sm">WhatsApp</span>
              </a>
            </div>
          </div>

          {/* Orari */}
          <div>
            <h4 
              className="font-bold text-lg mb-4 uppercase tracking-wide"
              style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
            >
              Orari
            </h4>
            <div className="text-zinc-400 text-sm space-y-1">
              <p>Lun - Ven: 9:00 - 12:30 / 15:00 - 19:00</p>
              <p>Sabato: 9:00 - 12:30</p>
              <p>Domenica: Chiuso</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-zinc-800 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-zinc-500 text-sm">
            © {new Date().getFullYear()} CAVW Commerciale Srl. Tutti i diritti riservati.
          </p>
          <p className="text-zinc-600 text-xs">
            P.IVA: 04111550481
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
